<template>
  <section class="section">
    <div class="container">
      <div class="columns">
        <div class="column is-offset-2 is-8">
          <div class="box">
            <h1 class="title">ユーザー新規登録</h1>
            <div class="field">
              <label class="label">ログインID</label>
              <div class="control">
                <input class="input" type="text" placeholder="ログインID" v-model="inputForm.username">
              </div>
            </div>
            <div class="field">
              <label class="label">表示名</label>
              <div class="control">
                <input class="input" type="text" placeholder="表示名" v-model="inputForm.dispname">
              </div>
            </div>
            <div class="field">
              <label class="label">パスワード</label>
              <div class="control">
                <input class="input" type="password" placeholder="パスワード" v-model="inputForm.password">
              </div>
            </div>
            <div class="field">
              <label class="label">確認のためもう一度</label>
              <div class="control">
                <input class="input" type="password" placeholder="パスワード" v-model="inputForm.confirmPassword">
              </div>
            </div>
            <div class="field">
              <div>
                <label for="lable" class="checkbox">
                  <input type="checkbox" id="admincheck" v-model="inputForm.isAdmin">管理者
                </label>
              </div>
              <div>
                <label for="lable" class="checkbox">
                  <input type="checkbox" id="admincheck" v-model="inputForm.isSubAdmin">補助管理者
                </label>
              </div>
            </div>
            <button class="button is-link" v-on:click="signup">登録する</button>&nbsp;&nbsp;
            <router-link to="/settings/members">
              <span class="button is-primary">
                <span class="icon"><i class="fa fa-backward"></i></span>&nbsp;&nbsp;戻　る
              </span>
            </router-link>
            <div>
              <span class="has-text-weight-bold is-size-4" v-if="hasMessage" v-bind:class="{'has-text-danger': isError}">{{ message }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
  import { mapState } from 'vuex'

  export default {
    data: function() {
      return {
        inputForm: {
          username: '',
          dispname: '',
          password: '',
          confirmPassword: '',
          isAdmin: false,
          isSubAdmin: false,
        },
        hasMessage: false,
        message: '',
        isError: false,
      }
    },
    computed:{
      ...mapState({
        apiStatus: state => state.item.apiStatus,
      })
    },
    methods: {
      clear(){
        //初期化
        Object.keys(this.inputForm).forEach((key) => {
          this.$set(this.inputForm, key, '')
        })
        this.$set(this.inputForm, 'isAdmin', false)
        this.$set(this.inputForm, 'isSubAdmin', false)
      },
      signup: function () {
        this.hasMessage = false;
        this.message = '';
        this.isError = false;
        const pattern = /^[a-zA-Z0-9_\-.]{3,15}$/g;
        if (this.inputForm.username === '') {
          this.hasMessage = true;
          this.message = 'ログインIDが空です';
          this.isError = true;
        } else if(this.inputForm.username.match(pattern) == null){
          this.hasMessage = true;
          this.message = 'ログインIDは3文字以上15文字以下で設定してください。\nまたログインIDで使用できるものは半角英数字のみです';
          this.isError = true;
        } else if(this.inputForm.dispname === ''){
          this.hasMessage = true;
          this.message = '表示名が空です';
          this.isError = true;
        } else if(this.inputForm.password.length < 6 ){
          this.hasMessage = true;
          this.message = 'パスワードは最低6文字以上を設定してください';
          this.isError = true;
        } else if (this.inputForm.password === '') {
          this.hasMessage = true;
          this.message = 'パスワードが空です';
          this.isError = true;
        } else if (this.inputForm.password !== this.inputForm.confirmPassword) {
          this.hasMessage = true;
          this.message = 'パスワードが合いません';
          this.isError = true;
        } else {
          this.submit()
        }
      },
      async submit(){
        await this.$store.dispatch('item/addUser', this.inputForm)
        if(this.apiStatus){
          this.$swal({
            position: 'top-end',
            icon: 'success',
            title: 'データを登録しました。',
            showConfirmButton: false,
            timer: 2000
          })
          this.clear()
        }
      }
    }
  }
</script>